<template>
  <div class="grid-view credit-control-save">
    <div class="main-content">
      <search-item
        config-module="5122"
        :custom-sim-query-placeholder="$t('advanceSearchForm.quickSearch')+':'+$t('Partners.parter')"
        :expand-adv="true"
        :custom-search-items="customSearchItems"
        :auto-init="searchItemAutoInit"
        @query="toQuery"
      >
        <template v-if="showPartnerButton" slot="operations">
          <!--新增-->
          <el-button v-if="$checkPermission(['write_SMPartner']) && !showIfRisk" no="toNew" type="primary" @click="toNew">{{ $t('Partners.add') }}</el-button>
          <!--删除-->
          <el-button v-if="($store.getters.isAdmin || $checkPermission(['button_SMPartner_deletePartner'])) && !showIfRisk" no="toDelete" type="danger" @click="toDelete">{{ $t('Partners.delete') }}</el-button>
          <!--查看-->
          <el-button no="toLook" type="primary" @click="toLook">{{ $t('Partners.view') }}</el-button>
          <!--提交-->
          <el-button no="toCommit" type="primary" @click="toCommit">{{ $t('CargoMsg.Cargo_Submit') }}</el-button>
          <!--审核-->
          <el-button v-if="auditBtnPermission" no="toAudit" type="primary" @click="toAudit">{{ $t('Partners.review') }}</el-button>
          <!--取消审核-->
          <el-button v-if="cancelAuditBtnPermission" no="toCancelAudit" type="primary" @click="toCancelAudit">{{ $t('CargoMsg.Cargo_CancelAudit') }}</el-button>
          <!--批量打印-->
          <el-button
            v-if="$checkPermission(['button_SMPartner_printPartner'])"
            no="toPrint"
            type="primary"
            @click="toPrint"
          >{{ $t('Partners.batchPrint') }}</el-button>
          <!--B2B注册邀请-->
          <el-button
            v-if="$checkPermission(['button_SMPartner_openB2B'])"
            no="toInviteB2B"
            type="primary"
            @click="toInviteB2B"
          >{{ $t('Partners.B2BRegistrationInvitation') }}</el-button>
          <!--运价授权-->
          <el-button
            v-if="$checkPermission(['button_SMPartner_authorizationPrice'])"
            no="toGrantPriceLevel"
            type="primary"
            @click="toGrantPriceLevel"
          >{{ $t('Partners.freightAuthorization') }}</el-button>
          <!--合并-->
          <el-button
            v-if="$checkPermission(['button_SMPartner_mergePartner']) && !showIfRisk"
            no="toMerge"
            type="primary"
            @click="toMerge"
          >{{ $t('Partners.combine') }}</el-button>
          <!--批量更改开票抬头-->
          <el-button v-if="$checkPermission(['button_SMPartner_batchEditInvoiceHeader']) && !showIfRisk" no="toEditInvoiceRiseByBatch" type="primary" @click="toEditInvoiceRiseByBatch">{{ $t('Partners.batchEditInvoiceHeader') }}</el-button>
          <!--CARGO-40477 13855兰高：合作伙伴服务人员批量新增-->
          <el-dropdown
            v-if="$checkPermission(['button_SMPartner_batchEditServer'])"
            split-button
            type="primary"
            no="batchAddOrUpdateServicePerson"
            style="margin:0 5px;"
            @click="btnAddOrUpdateServiceHandle()"
            @command="p=>{btnAddOrUpdateService=p;btnAddOrUpdateServiceHandle();}"
          >
            {{ btnAddOrUpdateService }}
            <el-dropdown-menu slot="dropdown">
              <!--批量新增服务人员-->
              <el-dropdown-item no="toAddServicePersonByBatch" :command="$t('Partners.batchAddServer')">{{ $t('Partners.batchAddServer') }}</el-dropdown-item>
              <!--批量更改服务人员-->
              <el-dropdown-item no="toEditServicePersonByBatch" :command="$t('Partners.batchEditServer')">{{ $t('Partners.batchEditServer') }}</el-dropdown-item>
              <!--批量修改联系人企微群聊-->
              <el-dropdown-item no="toEditEnterpriseWechatByBatch" :command="$t('CargoMsg.Cargo_BatchEditEnterpriseWechat')">{{ $t('CargoMsg.Cargo_BatchEditEnterpriseWechat') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!--模板下载-->
          <el-button v-if="!showIfRisk" no="btnInitTemplateClickHandler" type="primary" @click="btnInitTemplateClickHandler">{{ $t('Partners.templateDownload') }}</el-button>
          <!--导入-->
          <el-upload
            v-if="$checkPermission(['write_SMPartner']) && !showIfRisk"
            ref="upload"
            no="upload"
            :action="actionUrl"
            :headers="{sessionId}"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :before-upload="beforeUpload"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            style="display: inline-block;margin-left:5px;"
          >
            <el-button no="import" type="primary">{{ $t('Partners.import') }}</el-button>
          </el-upload>
          <!--下载导入结果-->
          <el-button v-if="$checkPermission(['write_SMPartner']) && !showIfRisk" no="btnDownLoadResultHandler" style="margin-left: 5px;" type="primary" @click="btnDownLoadResultHandler">{{ $t('Partners.downloadImportResults') }}</el-button>
          <!--导出代理清单-->
          <el-button
            v-if="serviceType === PartnerServiceItem.PARTNER_AGENT.code && $checkPermission(['button_SMPartner_exportAgents'])"
            no="exportAgentsHandler"
            style="margin-left: 5px;"
            type="primary"
            @click="exportAgentsHandler"
          >{{ $t('Partners.exportAgentList') }}</el-button>
          <el-button v-permission="['button_SMPartner_openDownloadPartner']" no="btnDownLoadPartnerHandler" style="margin-left: 5px;" type="primary" @click="btnDownLoadPartnerHandler">{{ $t('Partners.updateSupplierData') }}</el-button>
          <el-button v-permission="['button_SMPartner_maintainControl']" no="maintainControl" type="primary" @click="maintainControl">{{ $t('Partners.maintainInformation') }}</el-button>
          <el-button v-permission="['button_SMPartner_maintainControl']" no="maintainBlacklist" type="primary" @click="maintainBlacklist">{{ $t('Partners.batchBlacklistSetting') }}</el-button>
          <el-button v-permission="['button_SMPartner_maintainDefaultCreditInfo']" no="maintainDefaultCreditInfo" type="primary" @click="maintainDefaultCreditInfo">{{ $t('Partners.maintainDefaultCreditInfo') }}</el-button>
          <!--一键添加平台认证合作伙伴          -->
          <el-button v-show="wtOpenConfig && wtCreateCompany" type="primary" no="createWTCompanyHandler" @click="createWTCompanyHandler">{{ $t('Partners.credit_wtCreateCompany') }}</el-button>
          <img v-show="wtOpenConfig && wtCreateCompany" no="certificationPartners" src="/static/info.png" style="width: 20px;height: 18px; margin: 0 auto;" :title="$t('Partners.addPlatformCertificationPartners')">
        </template>
        <template slot="operations">
          <el-button v-if="$checkPermission(['button_SMPartner_newCustomerApplication'])" :style="showPartnerButton ? 'margin-left: 5px' : ''" type="primary" @click="newCustomerApplication(true)">
            {{ $t('CargoMsg.Cargo_NewCustomerApplication') }}
          </el-button>
          <el-button v-if="$checkPermission(['button_SMPartner_newSupplierApplication'])" type="primary" @click="newCustomerApplication(false)">{{ $t('CargoMsg.Cargo_NewSupplierApplication') }}</el-button>
        </template>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="101401"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          :has-export-role="!isSalesForSzfs"
          @gridReady="params=>{gridApi=params.api}"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="101401"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          :total="searchConditions.total"
          @pagination="toQuery()"
        />
      </div>
    </div>
    <!-- 用于打开新页面，并以post方式提交 -->
    <form ref="form" :action="url" target="_blank" method="post" style="display:none">
      <input v-for="(item,index) in formEntries" :key="index" no="url" :name="item.name" :value="item.value">
    </form>
    <!-- 批量打印对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
    <!-- 运价授权弹窗 -->
    <el-dialog v-el-drag-dialog :visible.sync="priceLevelDialog.visible" :title="$t('Partners.tariffLevelAuthorization')" width="380px" :close-on-click-modal="false">
      <div class="app-main-inner-row" style="padding-bottom:0px;">
        <el-form label-width="70px" label-position="left">
          <el-form-item :label="$t('Partners.fullContainerFreightRate')">
            <el-select v-model="priceLevelDialog.form.fcl" no="priceLevelFcl">
              <el-option label="Cost" :value="0" />
              <el-option label="Tier1" :value="1" />
              <el-option label="Tier2" :value="2" />
              <el-option label="Tier3" :value="3" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Partners.lclFreightRate')">
            <el-select v-model="priceLevelDialog.form.lcl" no="priceLevelLcl">
              <el-option label="Cost" :value="0" />
              <el-option :label="$t('SeaExport.PeerPrice')" :value="1" />
              <el-option :label="$t('SeaExport.DirectPrice')" :value="2" />
              <el-option :label="$t('SeaExport.MarketPrice')" :value="3" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Partners.airFreightRate')">
            <el-select v-model="priceLevelDialog.form.air" no="priceLevelAir">
              <el-option label="Cost" :value="0" />
              <el-option label="Tier1" :value="1" />
              <el-option label="Tier2" :value="2" />
              <el-option label="Tier3" :value="3" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Partners.fbaRate')">
            <el-select v-model="priceLevelDialog.form.fba" no="priceLevelFba">
              <el-option label="Cost" :value="0" />
              <el-option :label="$t('SeaExport.PeerPrice')" :value="1" />
              <el-option :label="$t('SeaExport.DirectPrice')" :value="2" />
              <el-option :label="$t('SeaExport.MarketPrice')" :value="3" />
            </el-select>
          </el-form-item>
          <span style="color:#D2D2D2">Tips:&nbsp;{{ $t('Partners.freightFateLevelIsAuthorized') }}</span>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="executeGrantPriceLevel" type="primary" @click="executeGrantPriceLevel">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="priceLevelCancel" @click="priceLevelDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 合并弹窗 -->
    <el-dialog
      ref="mergeDialog"
      v-el-drag-dialog
      :visible.sync="mergeDialog.visible"
      :title="$t('Partners.mergePartners')"
      width="950px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row">{{ $t('Partners.parter') }}：</div>
      <div class="app-main-inner-row">
        <b style="font-size: 15px;">{{ mergeDialog.partnerName }}</b>
      </div>
      <merge-partner ref="mergePartner" :service-type="serviceType" :merge-to-cmp-idx="mergeDialog.cmpIdx" />
      <span slot="footer">
        <el-button no="executeMerge" type="primary" @click="executeMerge">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="visibleCancel" @click="mergeDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 批量更改开票抬头弹窗 -->
    <el-dialog v-el-drag-dialog :visible.sync="editInvoiceHeadVisible" :title="$t('Partners.batchEditInvoiceHeader')" width="950px" :close-on-click-modal="false">
      <edit-invoice-head :check-h-q-read-only-permission="(rows) => checkHQReadOnlyPermission(rows)" />
      <span slot="footer">
        <el-button @click="editInvoiceHeadVisible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 批量更改服务人员弹窗(isSpecifiedSalesBusiness=1) -->
    <edit-company-user :check-h-q-read-only-permission="(rows) => checkHQReadOnlyPermission(rows)" :visible.sync="editCompanyUserVisible" @callback="updateRowData" />
    <!-- 批量更改销售员(isSpecifiedSalesBusiness=0) -->
    <edit-partner-sale :visible.sync="editPartnerSaleVisible" @callback="updateRowData" />
    <w-t-application-list-window :visible="openSendList.visible" @visibleHandler="visibleHandler" />
    <!-- 批量维护信控弹窗 -->
    <el-dialog
      ref="maintainInformation"
      v-el-drag-dialog
      :visible.sync="maintainCreditControl"
      :title="$t('Partners.maintainInformation')"
      width="950px"
      :close-on-click-modal="false"
    >
      <i class="title-block-color" />
      <span class="title">{{ $t('Partners.creditControlSettings') }}</span>
      <div style="margin-top:10px;">
        <div class="inner-row">
          <el-form :inline="true" label-width="80px" label-position="left" class="form-item-350">
            <el-form-item :label="$t('Partners.dateType')" class="margin-Right50">
              <el-select v-model="form.remarks" no="remarks">
                <el-option v-for="(item, index) in DATETYPE_TYPE" :key="index" :label="$getLangColumn(item)" :value="item.code" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('Invoice.invoice_settlementMethod')">
              <div style="display: flex">
                <el-select v-model="creditDateTypeObj.val1" no="val1">
                  <el-option :label="$t('Partners.monthlySettlement')" :value="-1" />
                  <el-option :label="$t('CargoMsg.Cargo_SettleByWeekly')" :value="-2" />
                  <el-option :label="$t('CargoMsg.Cargo_FixedDateMonthly')" value="n" />
                  <el-option :label="$t('Partners.space5')" :value="-3" />
                  <el-option :label="$t('Partners.dailySettlement')" :value="-4" />
                </el-select>
                <el-input-number
                  v-show="creditDateTypeObj.val1 === 'n' "
                  no="val2"
                  :value="creditDateTypeObj.val2 || undefined"
                  :min="0"
                  :precision="0"
                  :controls="false"
                  @input="val=>{creditDateTypeObj.val2=val}"
                />
              </div>
            </el-form-item>
            <br>
            <el-form-item :label="$t('Partners.accountPeriod')" class="margin-Right50">
              <div style="display: flex">
                <el-input-number
                  v-model="form.creditDateLimited"
                  no="creditDateLimited"
                  :min="0"
                  :precision="0"
                  controls-position="right"
                  style="width: 300px"
                />
                <el-select v-model="form.termUnit" no="termUnit" style="width: 200px;margin-left: 5px">
                  <el-option :label="$t('Partners.day')" :value="0" />
                  <el-option :label="$t('Partners.week')" :value="1" />
                  <el-option :label="$t('Partners.month')" :value="2" />
                </el-select>
              </div>
            </el-form-item>
            <el-form-item :label="$t('Partners.limit')">
              <div style="display: flex">
                <el-input-number
                  v-model="form.credit"
                  no="credit"
                  :min="0"
                  :precision="0"
                  :controls="false"
                  style="width: 300px"
                />
                <el-select v-model="form.currency" no="currency" style="margin-left:5px;width: 200px">
                  <el-option label="RMB" :value="'RMB'" />
                  <el-option label="USD" :value="'USD'" />
                </el-select>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="inner-row">
          <el-form :inline="true" label-width="80px" label-position="left">
            <el-form-item :label="$t('Payment.settlementType')">
              <el-radio-group no="settlementType" :disabled="true" :value="settlementType">
                <el-radio no="byTicket" :label="true">{{ $t('Message.ByTicket') }}</el-radio>
                <el-radio no="settlementNotByBill" :label="false">{{ $t('Partners.settlementNotByBill') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
        <div v-show="remindShow" style="color: red;">{{ $t('CargoMsg.Cargo_Prompt') }}：{{ $t('Partners.adjustContractInformationInBasicData') }}</div>
      </div>
      <span slot="footer">
        <el-button no="creditControlSave" type="primary" @click="creditControlSave">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="cancel" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 批量黑名单设置弹窗 -->
    <el-dialog
      ref="maintainBlacklistDialog"
      v-el-drag-dialog
      :visible.sync="maintainBlacklistVisible"
      :title="$t('Partners.batchBlacklistSetting')"
      width="420px"
      :close-on-click-modal="false"
    >
      <div style="margin-top:10px;">
        <el-form label-width="90px" label-position="left">
          <el-form-item :label="$t('Partners.blacklist')">
            <el-switch v-model="blacklistForm.blacklist" no="batchBlacklistSwitch" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="batchBlacklistSave" type="primary" @click="blacklistSave">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="batchBlacklistCancel" @click="blacklistCancel">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <default-credit-info-dialog :visible.sync="maintainDefaultCreditControl" />
    <!-- 批量新增服务人员弹窗-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="$t('Partners.addServicePersonnel')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row">
        <el-form label-width="90px" label-position="left">
          <!--岗位类型-->
          <el-form-item :label="$t('Partners.positionType')">
            <el-select v-model="editDialog.form.roleType" no="roleType" @change="roleTypeChange">
              <el-option
                v-for="(item,index) in roleTypes"
                :key="index"
                :label="isZh ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <!--业务类型-->
          <el-form-item :label="$t('Payment.businessType')">
            <el-select v-model="editDialog.form.lob" no="lob" @change="lobChange">
              <el-option :label="$t('SeaExport.All')" value="ALL" />
              <el-option
                v-for="(item,index) in lobs"
                :key="index"
                :label="isZh ? item.chineseName : item.englishName"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-show="showCargoSource" :label="$t('SeaExport.SolicitationType')">
            <el-select v-model="editDialog.form.cargoSource" no="cargoSource" :clearable="true">
              <el-option :label="$t('Partners.customerSpace2')" value="NC" />
              <el-option :label="$t('Partners.customerSpace3')" value="SC" />
            </el-select>
          </el-form-item>
          <!--用户名称-->
          <el-form-item :label="$t('Partners.userName')">
            <cargo-user-select
              ref="userSelect"
              no="userId"
              :method-params="{category:'role',shape:getRoleTypeEnglishName(editDialog.form.roleType)}"
              :default-value="editDialog.form.userId||''"
              style="width: 200px"
              :show-custom-label-in-option="true"
              :custom-label="userCustomLabel"
              :init-default-option="true"
              @change="p=>{editDialog.form.userId=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('Partners.isDefault')">
            <el-radio-group v-model="editDialog.form.defaultUser" no="defaultUser">
              <el-radio no="yes" :label="true">{{ $t('Message.Yes') }}</el-radio>
              <el-radio no="no" :label="false">{{ $t('Message.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('Payment.remarks')">
            <el-input v-model="editDialog.form.remarks" no="remarks" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="saveSub" type="primary" @click="btnAddServiceSaveHandle">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!--批量修改联系人企微群聊-->
    <edit-enterprise-wechat :check-h-q-read-only-permission="(rows) => checkHQReadOnlyPermission(rows)" :visible.sync="editEnterpriseWechatVisible" @callback="updateRowData" />
    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="'PT'"
      :jobs="batchCheckingWindow.jobs"
      :batch-create-job="true"
      :append-to-body="true"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
      :close-callback="batchCheckingWindow.closeCallback"
    />

    <company-apply-dialog
      v-if="companyApplyWindow.visible"
      ref="companyApplyDialog"
      :visible.sync="companyApplyWindow.visible"
      :company-bpm="companyApplyWindow.companyBpm"
      :title="$t('CargoMsg.Cargo_PartnerApplicationApprovalProcess')"
      type="apply"
      @close="companyApplyWindow.visible=false"
      @closeAndRefresh="closeAndRefresh"
    />
    <!--新增客户申请-->
    <customer-application-dialog :visible.sync="customerApplicationDialogVisible" />
    <!--新增供应商申请-->
    <supplier-application-dialog :visible.sync="supplierApplicationDialogVisible" />
  </div>
</template>

<script>
import * as CargoOfRoleTypeUtil from '@/class/cargo/model/utils/CargoOfRoleTypeUtil'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import mergePartner from './mergePartner'
import editInvoiceHead from './editInvoiceHead'
import editCompanyUser from './editCompanyUser'
import editPartnerSale from './editPartnerSale'
import WTApplicationListWindow from '@/views/cargo/v0/Information/components/partner/WTApplicationListWindow'
import { getSearchConditionDropList } from './tab/PartnerUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import selectData from '@/utils/selectData'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { getToken } from '@/utils/auth'
import { cache, cacheName } from '@/utils/cacheManager'
import { ensureExecuteSuccess, SyncManager } from '@/utils/commonUtil'
import { Company } from '@/class/model/mdm/Company'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as PartnerServiceItem from '@/class/cargo/model/parameters/PartnerServiceItem'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import {
  addPartnerAuthorizationByBatch,
  batchQueryCustomerCompanyIsOver,
  batchSaveBlacklist,
  batchSaveCreditInfos,
  cancelAuditCompany,
  checkQuotationClient,
  checkUsedByAccountingDocument,
  delCompany,
  deleteCompanyCRMFunc,
  downLoadPartners,
  getAdvancedList,
  getCompanyList,
  hasPartnerPrivilegeBranches,
  mergeCompanies
} from '@/api/company'
import { getUserDepartmentTeamWithChild } from '@/api/user'
import { getSupplierDepartmentPermissions } from '@/api/partner/permissionCheck'
import URL from '@/api/urlTranslator'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getGridSelected } from '@/utils/agGrid'
import { updateBasicDataForSingle } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import DefaultCreditInfoDialog from '@/views/cargo/v0/Information/components/partner/tab/defaultCreditInfoDialog.vue'
import { batchAddUser } from '@/api/partner/companyUser'
import { DATETYPE_TYPE } from '@/class/cargo/model/parameters/ContractConstants'
import editEnterpriseWechat from './editEnterpriseWechat'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow.vue'
import { checkAnyContent } from '@/api/sysManage/baseConfig/checkRuleConfig'
import { createCompanyBpmFunc } from '@/api/partner/companyBpm'
import CompanyApplyDialog from '@/components/Cargo/Common/Wrokflow/companyApplyDialog.vue'
import CustomerApplicationDialog from './tab/customerApplicationDialog.vue'
import SupplierApplicationDialog from './tab/supplierApplicationDialog.vue'

export default {
  name: 'PartnerList',
  components: {
    SupplierApplicationDialog, CustomerApplicationDialog,
    CompanyApplyDialog,
    BatchCheckingWindow, DefaultCreditInfoDialog, searchItem, cargoAdvanceSelect, cargoTemplateSelectorDialog, mergePartner, editInvoiceHead, editCompanyUser, editPartnerSale, WTApplicationListWindow, cargoUserSelect, editEnterpriseWechat },
  props: {
    serviceType: { type: String, default: '' },
    isSalesForSzfs: { type: Boolean, default: false } // 深圳丰收销售专用
  },
  data() {
    return {
      DATETYPE_TYPE,
      remindShow: false,
      creditDateTypeObj: {
        val1: -1,
        val2: 0
      },
      form: {
        creditDateLimited: 0,
        termUnit: 0,
        credit: 0,
        currency: 'RMB',
        remarks: 'ETD'
      },
      maintainCreditControl: false,
      maintainBlacklistVisible: false,
      blacklistForm: {
        blacklist: false
      },
      maintainDefaultCreditControl: false,
      loading: null,
      useCheckRule: false,
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        closeCallback: null,
        callBack2: null
      },
      ...selectData,
      PartnerServiceItem,
      partnersApproved: 0,
      wtOpenConfig: false,
      isHC: false,
      extendedInterestRate: false, // 是否显示免息公司
      showIfRisk: false,
      differentiateCustomerAndSupplierFees: false, // 区分客户和供应商费用
      isCancelPartnersApproved: false, // 合作伙伴“取消审核”按钮 当参数PartnersApproved配置等于1/2/3时，显示此按钮。
      hasDepartmentPartner: this.$checkPermission(['role_CustomerPartners_departmentPartner']),
      viewAllPartner: this.$checkPermission(['role_CustomerPartners_viewAllPartner']),
      viewAllSupplierHc: this.$checkPermission(['all_supplier']),
      isAdmin: this.$store.getters.isAdmin,
      departmentUserTerm: '',
      supplierDepartmentTerm: '',
      companyUserTerm: '',
      wtCreateCompany: this.$checkPermission(['button_partner_wtCreateCompany']),
      searchItemAutoInit: false,
      customSearchItems: [],
      filterInit: {
        serviceType: '',
        currentBranchId: '',
        branchId: '',
        companyName: '',
        companyType: '',
        roleType: 2,
        companyUser: '',
        customerTypeId: '',
        remarks: '',
        approvedState: '',
        active: '',
        volumeOption: '=',
        volume: '',
        signContract: '',
        region: '',
        createdBy: '',
        createdBeginDate: '',
        createdEndDate: '',
        approvedBeginDate: '',
        approvedEndDate: '',
        approvedDateIsNull: '',
        pageNum: 1,
        pageSize: 20,
        customerSourceUuid: '',
        warehouseType: ''
      },
      filter: {},
      departmentUserTerm: '',
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('baseInfo.partner.cmpIdx'),
          colId: 'cmpIdx',
          field: 'cmpIdx',
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true
          },
          checkboxSelection: true,
          width: 120,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          pinned: 'left'
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onRowDoubleClicked: () => {
          this.toLook()
        },
        onSortChanged: event => {
          if (this.selectedNode) {
            event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      rowData: [],
      selectedNode: null,
      gridApi: null,
      url: '',
      formEntries: [],
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'PARTNER',
        data: {
          COMPANY_UUID: [''],
          USER_ID: ''
        }
      },
      priceLevelDialog: {
        visible: false,
        form: {
          uuidList: [],
          fcl: 0,
          lcl: 0,
          air: 0,
          fba: 0
        }
      },
      mergeDialog: {
        visible: false,
        partnerName: '',
        fromUuid: '',
        cmpIdx: ''
      },
      openSendList: { // 一键添加平台认证合作伙伴
        visible: false
      },
      editInvoiceHeadVisible: false,
      editCompanyUserVisible: false,
      editPartnerSaleVisible: false,
      exportResult: '',
      syncManager: new SyncManager(),
      searchConditions: {
        total: 0, // total传递到后端无用
        pageNum: 1,
        pageSize: 20,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      partnerPrivilegeBranches: null,
      btnAddOrUpdateService: this.$t('Partners.batchEditServer'),
      lobs: [],
      roleTypes: [],
      editDialog: {
        visible: false,
        form: {
          roleType: '',
          lob: '',
          userId: '',
          defaultUser: false,
          remarks: '',
          cargoSource: ''
        },
        initForm: {
          roleType: '',
          lob: '',
          userId: '',
          defaultUser: false,
          remarks: '',
          cargoSource: ''
        }
      },
      btnRole: {
        partnersAuditBtnPermission: this.$checkPermission(['button_SMPartner_partnersApproved']),
        partnersCancelAuditBtnPermission: this.$checkPermission(['button_SMPartner_partnersCancelAudit']),
        customerAuditBtnPermission: this.$checkPermission(['button_SMPartner_customerApproved']),
        customerCancelAuditBtnPermission: this.$checkPermission(['button_SMPartner_customerCancelApproved']),
        supplierAuditBtnPermission: this.$checkPermission(['button_SMPartner_supplierApproved']),
        supplierCancelAuditBtnPermission: this.$checkPermission(['button_SMPartner_supplierCancelApproved'])
      },
      companyApplyWindow: {
        visible: false,
        companyBpm: {}
      },
      editEnterpriseWechatVisible: false,
      customerApplicationDialogVisible: false,
      supplierApplicationDialogVisible: false
    }
  },
  computed: {
    settlementType() {
      return this.form.creditDateLimited === 0 && this.creditDateTypeObj.val1 !== 'n'
    },
    readonly() {
      return !this.action || this.action === 'look'
    },
    sessionId() {
      return this.$store.getters.token
    },
    currentOfficeId() {
      return this.$store.getters.currentOfficeId
    },
    auditBtnPermission() {
      return this.partnersApproved > 0 && (this.serviceType === PartnerServiceItem.PARTNER_CUSTOMER.code && this.$checkPermission(['button_CustomerPartners_audit'])) ||
        ((this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code && this.btnRole.partnersAuditBtnPermission) ||
        (this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code && this.btnRole.customerAuditBtnPermission) ||
        (this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code && this.btnRole.supplierAuditBtnPermission))
    },
    cancelAuditBtnPermission() {
      return this.isCancelPartnersApproved && (this.btnRole.partnersCancelAuditBtnPermission ||
        (this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code && this.btnRole.customerCancelAuditBtnPermission) ||
        (this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code && this.btnRole.supplierCancelAuditBtnPermission))
    },
    actionUrl() {
      return URL.partner.saveCustomerInfoFromExcel + '?sessionId=' + this.sessionId + '&currentBranchId=' + this.currentOfficeId + '&fileName=ImportPartnerResult.xls&folderName=partner'
    },
    columnDefs() { // 显示列
      const tempColumnDefs = [
        {
          headerName: this.$t('baseInfo.partner.shortName'),
          field: 'shortName',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.partner.cnShortName'),
          field: 'cnShortName',
          width: 100
        }, {
          headerName: this.$t('Partners.country'),
          field: 'region',
          width: 200,
          cellRenderer: params => {
            if (params.value) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', params.value, 'chineseName')
            }
            return ''
          }
        }, {
          headerName: this.$t('baseInfo.partner.chineseName'),
          field: 'chineseName',
          width: 200
        }, {
          headerName: this.$t('baseInfo.partner.englishName'),
          field: 'englishName',
          width: 200
        }, {
          headerName: this.$t('Partners.ClientContractStatus'),
          field: 'contractStatus',
          colId: 'contractStatus',
          width: 150,
          cellRenderer: (params) => {
            return this.contractStatusLabFun(params.value)
          }
        }, {
          headerName: this.$t('Partners.additionalDescription'),
          field: 'remarks',
          width: 200
        }, {
          headerName: this.$t('baseInfo.partner.branchId'),
          field: 'branchId',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.getOfficeLabel('officeId', params.value)
          }
        }, {
          headerName: this.$t('baseInfo.partner.approvedState'),
          field: 'approvedState',
          width: 110,
          cellRenderer: params => {
            switch (Number(params.value)) {
              case 1:
                return this.$t('Message.Approved')
              case 2:
                return this.$t('CargoMsg.Cargo_Denied')
              case 3:
                return this.$t('CargoMsg.Cargo_UnderReview')
              default:
                return this.$t('CargoMsg.Cargo_NotReviewed')
            }
          }
        }, {
          headerName: this.$t('Partners.RefuseRemark'),
          field: 'rejectReason',
          width: 200
        }, {
          headerName: this.$t('baseInfo.partner.approvedBy'),
          field: 'approvedBy',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('baseInfo.partner.dateApproved'),
          field: 'dateApproved',
          width: 200,
          cellRenderer: params => {
            return params.value ? params.value.substr(0, 10) : ''
          }
        }, {
          headerName: this.$t('baseInfo.partner.createBy'),
          field: 'createdBy',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('baseInfo.partner.dateCreated'),
          field: 'dateCreated',
          width: 200,
          cellRenderer: params => {
            return params.value ? params.value.substr(0, 10) : ''
          }
        }, {
          headerName: this.$t('baseInfo.partner.modifiedBy'),
          field: 'modifiedBy',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('baseInfo.partner.dateModified'),
          field: 'dateModified',
          width: 200,
          cellRenderer: params => {
            return params.value ? params.value.substr(0, 10) : ''
          }
        }, {
          headerName: this.$t('baseInfo.partner.isActive'),
          field: 'active',
          width: 100,
          cellRenderer: params => {
            return params.value ? this.$t('CargoMsg.Cargo_Yes') : this.$t('CargoMsg.Cargo_No')
          }
        }, {
          headerName: this.$t('Partners.inactiveReason'),
          field: 'inactiveReason',
          width: 200
        }, {
          headerName: this.$t('baseInfo.partner.relateTenantUuid'),
          field: 'relateTenantUuid',
          width: 200,
          cellRenderer: params => {
            return params.value ? '√' : ''
          }
        }, {
          headerName: this.$t('baseInfo.partner.sales'),
          field: 'sales',
          width: 300,
          cellRenderer: (params) => {
            let value = ''
            if (params.value) {
              const arr = params.value.split(',')
              const defaultValue = params.data.salesDefaultValue
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
                if (defaultValue) {
                  const exitDefault = defaultValue.find(item => Number(item) === Number(arr[index]))
                  if (exitDefault) {
                    value += '(' + this.$t('CargoMsg.Cargo_Default') + ')'
                  }
                }
              }
            }
            return value
          }
        },
        {
          headerName: this.$t('Payment.settlementType'),
          field: 'settlementType',
          colId: 'settlementType',
          width: 150,
          cellRenderer: params => {
            return this.settlementTypeLabFun(params.data)
          },
          filterParams: {},
          filterValueGetter: params => {
            return this.settlementTypeLabFun(params.data)
          }
        },
        // 日期类型
        {
          headerName: this.$t('Partners.credit_creditControl_date'),
          field: 'dateType',
          width: 200,
          cellRenderer: params => {
            return this.dateTypeConvert(params.data)
          },
          filterParams: {},
          filterValueGetter: params => {
            return this.dateTypeConvert(params.data)
          }
        },
        // 结算方式
        {
          headerName: this.$t('baseInfo.partner.creditDateType'),
          field: 'creditDateType',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.creditDateTypeMultiLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: params => {
            return ColumnUtils.creditDateTypeMultiLabelFunc(params.data)
          }
        },
        // 黑名单
        {
          headerName: this.$t('baseInfo.partner.blacklist'),
          field: 'blacklist',
          width: 200,
          cellRenderer: params => {
            if (params.value !== '') {
              return params.value ? this.$t('Information.Yes') : this.$t('Information.No')
            } else {
              return
            }
          }
        },
        // 揽货类型 SC自揽货，NC指定货
        {
          headerName: this.$t('baseInfo.partner.cargoSource'),
          field: 'cargoSource',
          width: 200
        },
        // 收支类型 true-收款、false-付款
        {
          headerName: this.$t('baseInfo.partner.receivableDeposit'),
          field: 'receivableDeposit',
          width: 200,
          cellRenderer: params => {
            if (params.value !== '') {
              return params.value ? this.$t('Partners.collections') : this.$t('Partners.payment')
            } else {
              return
            }
          }
        },
        // 账期（termUnit单位0-天，1-周，2-月）（creditDateLimited单位）
        {
          headerName: this.$t('baseInfo.partner.accountingPeriod'),
          field: 'accountingPeriod',
          width: 200,
          cellRenderer: params => {
            return this.accountingPeriodLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: params => {
            return this.accountingPeriodLabelFunc(params.data)
          }
        },
        // 额度 （currency单位RMB-RMB，USD-USD）（credit额度）
        {
          headerName: this.$t('baseInfo.partner.quota'),
          field: 'quota',
          width: 200,
          cellRenderer: params => {
            return this.creditLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: params => {
            return this.creditLabelFunc(params.data)
          }
        },
        {
          headerName: this.$t('baseInfo.partner.creditQuota'),
          field: 'credit',
          hide: true,
          width: 100
        },
        {
          headerName: this.$t('baseInfo.partner.creditCurrency'),
          field: 'currency',
          hide: true,
          width: 100
        },
        {
          headerName: this.$t('baseInfo.partner.freightVolume30'),
          field: 'freightVolume30',
          width: 100
        }, {
          headerName: this.$t('baseInfo.partner.freightVolume60'),
          field: 'freightVolume60',
          width: 100
        }, {
          headerName: this.$t('baseInfo.partner.freightVolume90'),
          field: 'freightVolume90',
          width: 100
        }, {
          headerName: this.$t('baseInfo.partner.freightVolumeGt90'),
          field: 'freightVolumeGt90',
          width: 110
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SourceOfClient'),
          field: 'customerSource',
          width: 110
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CustomerContactChannel'),
          field: 'customerContactChannel',
          hide: true,
          cellRenderer: (params) => {
            return ColumnUtils.customerContactChannelLabelFun(params.value)
          },
          width: 140
        },
        {
          headerName: this.$t('Partners.supplierPrincipal'),
          field: 'supplierDirector',
          hide: true,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          },
          width: 140
        },
        {
          headerName: this.$t('Partners.customerSupplierType'),
          field: 'customerSupplierType',
          cellRenderer: params => {
            return ColumnUtils.generateCustomerSupplierTypeContent(params.data)
          },
          width: 200
        },
        {
          headerName: this.$t('SeaExport.Addr'),
          field: 'address',
          width: 200,
          hide: true
        }, {
          headerName: this.$t('SeaExport.CustomerLevel'),
          field: 'customerTypeId',
          cellRenderer: params => {
            return ColumnUtils.companyCustomerTypeLabelFunc(params.value)
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('Partners.departmentBelonging'),
          field: 'ownerDepartment',
          width: 150,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Department_All, 'departmentId', params.value, 'chineseName')
          },
          hide: true
        }, {
          headerName: this.$t('Partners.interestFreeCompany'),
          field: 'interestFree',
          width: 100,
          hide: !this.extendedInterestRate,
          suppressColumnsToolPanel: !this.extendedInterestRate,
          cellRenderer: params => {
            return ColumnUtils.IsBookedLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.SalesOfGoods'),
          field: 'canvassSales',
          width: 300,
          hide: true,
          suppressColumnsToolPanel: !(Number(cache.config.get('IsSpecifiedSalesBusiness')) === 1),
          cellRenderer: (params) => {
            let value = ''
            if (params.value) {
              const arr = params.value.split(',')
              const defaultValue = params.data.canvassSalesDefaultValue
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
                if (defaultValue) {
                  const exitDefault = defaultValue.find(item => Number(item) === Number(arr[index]))
                  if (exitDefault) {
                    value += '(' + this.$t('CargoMsg.Cargo_Default') + ')'
                  }
                }
              }
            }
            return value
          }
        }, {
          headerName: this.$t('SeaExport.CustomerService'),
          field: 'csr',
          colId: 'csr',
          width: 300,
          hide: true,
          suppressColumnsToolPanel: !(Number(cache.config.get('IsSpecifiedSalesBusiness')) === 1),
          valueFormatter: (params) => {
            let value = ''
            if (params.value) {
              const arr = params.value.split(',')
              const defaultValue = params.data.csrDefaultValue
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
                if (defaultValue) {
                  const exitDefault = defaultValue.find(item => Number(item) === Number(arr[index]))
                  if (exitDefault) {
                    value += '(' + this.$t('CargoMsg.Cargo_Default') + ')'
                  }
                }
              }
            }
            return value
          },
          filterParams: {},
          filterValueGetter: (params) => {
            let value = ''
            if (params.data.csr && params.data.csr !== undefined) {
              const arr = params.data.csr.split(',')
              const defaultValue = params.data.csrDefaultValue
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
                if (defaultValue) {
                  const exitDefault = defaultValue.find(item => Number(item) === Number(arr[index]))
                  if (exitDefault) {
                    value += '(' + this.$t('CargoMsg.Cargo_Default') + ')'
                  }
                }
              }
            }
            return value
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_CustomerServiceOverSea'),
          field: 'overseaOp',
          width: 300,
          valueFormatter: (params) => {
            let value = ''
            if (params.value) {
              const arr = params.value.split(',')
              const defaultValue = params.data.overseaOpDefaultValue
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
                if (defaultValue) {
                  const exitDefault = defaultValue.find(item => Number(item) === Number(arr[index]))
                  if (exitDefault) {
                    value += '(' + this.$t('CargoMsg.Cargo_Default') + ')'
                  }
                }
              }
            }
            return value
          },
          filterParams: {},
          filterValueGetter: (params) => {
            let value = ''
            if (params.data.overseaOp && params.data.overseaOp !== undefined) {
              const arr = params.data.overseaOp.split(',')
              const defaultValue = params.data.overseaOpDefaultValue
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
                if (defaultValue) {
                  const exitDefault = defaultValue.find(item => Number(item) === Number(arr[index]))
                  if (exitDefault) {
                    value += '(' + this.$t('CargoMsg.Cargo_Default') + ')'
                  }
                }
              }
            }
            return value
          }
        }, {
          headerName: this.$t('Partners.networkManager'),
          field: 'owner',
          width: 300,
          cellRenderer: (params) => {
            return params.value ? ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName') : ''
          }
        }, {
          headerName: this.$t('Partners.customerCode'),
          field: 'externalKeyCust',
          width: 300,
          hide: true
        }, {
          headerName: this.$t('Partners.supplierCode'),
          field: 'externalKeyVend',
          width: 300,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_CategoryOfPartner'),
          field: 'partnerType',
          cellRenderer: params => {
            return ColumnUtils.generatePartnerTypeContent(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.generatePartnerTypeContent(params.data)
          },
          width: 200,
          hide: true,
          suppressColumnsToolPanel: !this.differentiateCustomerAndSupplierFees
        }, {
          headerName: this.$t('Partners.BookingAgentLevel'),
          field: 'bookingAgentLevel',
          width: 300,
          cellRenderer: (params) => {
            return ColumnUtils.resolveBookingAgentLevel(params.value)
          },
          suppressColumnsToolPanel: !(String(cache.config.get('ToExoSystem')) === 'zy'),
          hide: true
        }, {
          headerName: this.$t('Partners.CreditRemarks'),
          field: 'creditRemarks',
          width: 200,
          hide: true
        }, {
          headerName: this.$t('Partners.SupplierContractStatus'),
          field: 'supplierContractStatus',
          colId: 'supplierContractStatus',
          cellRenderer: (params) => {
            return this.contractStatusLabFun(params.value)
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('Partners.OverseasAgencyContractStatus'),
          field: 'overseasAgencyContractStatus',
          colId: 'overseasAgencyContractStatus',
          cellRenderer: (params) => {
            return this.contractStatusLabFun(params.value)
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('Partners.OtherContractStatus'),
          field: 'otherContractStatus',
          colId: 'otherContractStatus',
          cellRenderer: (params) => {
            return this.contractStatusLabFun(params.value)
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('Partners.ContractApproxStatus'),
          field: 'contractApproxStatus',
          colId: 'contractApproxStatus',
          cellRenderer: (params) => {
            return this.contractStatusLabFun(params.value)
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('Partners.IfRisk'),
          field: 'ifRisk',
          width: 200,
          hide: true,
          suppressColumnsToolPanel: !this.showIfRisk,
          cellRenderer: params => {
            return params.value ? this.$t('CargoMsg.Cargo_Yes') : this.$t('CargoMsg.Cargo_No')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_carrierType'),
          field: 'carrierTypes',
          colId: 'carrierTypes',
          cellRenderer: (params) => {
            if (!params.data.carrierTypes) {
              return ''
            }
            return params.data.carrierTypes.split('|')
              .map(item => ColumnUtils.resolveCarrierType(Number(item))).join('|')
          },
          filterParams: {},
          filterValueGetter: params => {
            if (!params.data.carrierTypes) {
              return ''
            }
            return params.data.carrierTypes.split('|').map(item => ColumnUtils.resolveCarrierType(Number(item))).join('|')
          },
          width: 150,
          hide: true
        },
        {
          headerName: this.$t('SeaExport.FileNo'),
          field: 'contractNo',
          width: 200
        },
        {
          headerName: this.$t('Partners.whetherUploadContractAttachment'),
          field: 'uploadDocument',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Documents'),
          field: 'doc',
          colId: 'doc',
          hide: true,
          width: 300,
          cellRenderer: (params) => {
            let value = ''
            if (params.value) {
              const arr = params.value.split(',')
              const defaultValue = params.data.docDefaultValue
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
                if (defaultValue) {
                  const exitDefault = defaultValue.find(item => Number(item) === Number(arr[index]))
                  if (exitDefault) {
                    value += '(' + this.$t('CargoMsg.Cargo_Default') + ')'
                  }
                }
              }
            }
            return value
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole1'),
          field: 'userDefinedRole1',
          colId: 'userDefinedRole1',
          hide: true,
          width: 300,
          cellRenderer: (params) => {
            let value = ''
            if (params.value) {
              const arr = params.value.split(',')
              const defaultValue = params.data.userDefinedRole1DefaultValue
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
                if (defaultValue) {
                  const exitDefault = defaultValue.find(item => Number(item) === Number(arr[index]))
                  if (exitDefault) {
                    value += '(' + this.$t('CargoMsg.Cargo_Default') + ')'
                  }
                }
              }
            }
            return value
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_userDefinedRole2'),
          field: 'userDefinedRole2',
          colId: 'userDefinedRole2',
          hide: true,
          width: 300,
          cellRenderer: (params) => {
            let value = ''
            if (params.value) {
              const arr = params.value.split(',')
              const defaultValue = params.data.userDefinedRole2DefaultValue
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
                if (defaultValue) {
                  const exitDefault = defaultValue.find(item => Number(item) === Number(arr[index]))
                  if (exitDefault) {
                    value += '(' + this.$t('CargoMsg.Cargo_Default') + ')'
                  }
                }
              }
            }
            return value
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole3'),
          field: 'userDefinedRole3',
          colId: 'userDefinedRole3',
          hide: true,
          width: 300,
          cellRenderer: (params) => {
            let value = ''
            if (params.value) {
              const arr = params.value.split(',')
              const defaultValue = params.data.userDefinedRole3DefaultValue
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
                if (defaultValue) {
                  const exitDefault = defaultValue.find(item => Number(item) === Number(arr[index]))
                  if (exitDefault) {
                    value += '(' + this.$t('CargoMsg.Cargo_Default') + ')'
                  }
                }
              }
            }
            return value
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole4'),
          field: 'userDefinedRole4',
          colId: 'userDefinedRole4',
          hide: true,
          width: 300,
          cellRenderer: (params) => {
            let value = ''
            if (params.value) {
              const arr = params.value.split(',')
              const defaultValue = params.data.userDefinedRole4DefaultValue
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
                if (defaultValue) {
                  const exitDefault = defaultValue.find(item => Number(item) === Number(arr[index]))
                  if (exitDefault) {
                    value += '(' + this.$t('CargoMsg.Cargo_Default') + ')'
                  }
                }
              }
            }
            return value
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole5'),
          field: 'userDefinedRole5',
          colId: 'userDefinedRole5',
          hide: true,
          width: 300,
          cellRenderer: (params) => {
            let value = ''
            if (params.value) {
              const arr = params.value.split(',')
              const defaultValue = params.data.userDefinedRole5DefaultValue
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
                if (defaultValue) {
                  const exitDefault = defaultValue.find(item => Number(item) === Number(arr[index]))
                  if (exitDefault) {
                    value += '(' + this.$t('CargoMsg.Cargo_Default') + ')'
                  }
                }
              }
            }
            return value
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole6'),
          field: 'userDefinedRole6',
          colId: 'userDefinedRole6',
          hide: true,
          width: 300,
          cellRenderer: (params) => {
            let value = ''
            if (params.value) {
              const arr = params.value.split(',')
              const defaultValue = params.data.userDefinedRole6DefaultValue
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
                if (defaultValue) {
                  const exitDefault = defaultValue.find(item => Number(item) === Number(arr[index]))
                  if (exitDefault) {
                    value += '(' + this.$t('CargoMsg.Cargo_Default') + ')'
                  }
                }
              }
            }
            return value
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_userDefinedRole7'),
          field: 'userDefinedRole7',
          colId: 'userDefinedRole7',
          hide: true,
          width: 300,
          cellRenderer: (params) => {
            let value = ''
            if (params.value) {
              const arr = params.value.split(',')
              const defaultValue = params.data.userDefinedRole7DefaultValue
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
                if (defaultValue) {
                  const exitDefault = defaultValue.find(item => Number(item) === Number(arr[index]))
                  if (exitDefault) {
                    value += '(' + this.$t('CargoMsg.Cargo_Default') + ')'
                  }
                }
              }
            }
            return value
          }
        }
      ]
      if (this.isHC) {
        tempColumnDefs.push({
          headerName: this.$t('SeaExport.Operation'),
          field: 'op',
          colId: 'op',
          width: 300,
          hide: true,
          suppressColumnsToolPanel: !(Number(cache.config.get('IsSpecifiedSalesBusiness')) === 1),
          valueFormatter: (params) => {
            let value = ''
            if (params.value) {
              const arr = params.value.split(',')
              const defaultValue = params.data.opDefaultValue
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
                if (defaultValue) {
                  const exitDefault = defaultValue.find(item => Number(item) === Number(arr[index]))
                  if (exitDefault) {
                    value += '(' + this.$t('CargoMsg.Cargo_Default') + ')'
                  }
                }
              }
            }
            return value
          },
          filterParams: {},
          filterValueGetter: (params) => {
            let value = ''
            if (params.data.op && params.data.op !== undefined) {
              const arr = params.data.op.split(',')
              const defaultValue = params.data.opDefaultValue
              for (const index in arr) {
                if (index > 0) value += '/'
                value += ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(arr[index]), 'chineseName')
                if (defaultValue) {
                  const exitDefault = defaultValue.find(item => Number(item) === Number(arr[index]))
                  if (exitDefault) {
                    value += '(' + this.$t('CargoMsg.Cargo_Default') + ')'
                  }
                }
              }
            }
            return value
          }
        })
      }
      if (!this.isSalesForSzfs) {
        tempColumnDefs.push(
          {
            headerName: this.$t('CargoMsg.Cargo_CreateSource'),
            field: 'createSource',
            width: 110,
            initialHide: this.isSalesForSzfs,
            suppressColumnsToolPanel: this.isSalesForSzfs,
            valueFormatter: (params) => {
              if (params.value === 1) {
                return this.$t('Menu.WallTechFamily')
              } else if (params.value === 2) {
                return 'eTowerOne'
              } else {
                return 'cargoWare'
              }
            }
          }
        )
      }
      return tempColumnDefs
    },
    showCargoSource() {
      return !(this.editDialog.form.roleType === CargoOfRoleType.SALES_TYPE.code || this.editDialog.form.roleType === CargoOfRoleType.SALES_OF_GOODS.code ||
        this.editDialog.form.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code || this.editDialog.form.roleType === CargoOfRoleType.OP_TYPE.code) && this.editDialog.form.lob === 'SE'
    },
    isZh() {
      return this.$i18n.locale === 'zh'
    },
    showPartnerButton() {
      if (this.$store.getters.isAdmin) {
        return true
      }
      if (this.$checkPermission(['button_SMPartner_newCustomerApplication']) || this.$checkPermission(['button_SMPartner_newSupplierApplication'])) {
        return false
      }
      return true
    }
  },
  watch: {
    currentOfficeId: {
      immediate: true,
      handler() {
        ensureExecuteSuccess(() => cache.config).then(() => {
          this.partnersApproved = Number(cache.config.get('PartnersApproved'))
        })
        this.departmentUserTerm = ''
        this.companyUserTerm = ''
        if (this.isAdmin) {
          this.supplierDepartmentTerm = ''
          this.companyUserTerm = 'all'
          return
        }
        // 获取部门下的用户ID集合
        if (this.viewAllPartner) {
          this.companyUserTerm = 'all'
        } else if (this.hasDepartmentPartner) {
          // departments 传空数组：后端自动取当前登录用户所属的全部部门，并展开各自子部门（同组及下级部门）
          getUserDepartmentTeamWithChild({ departments: [], branchId: this.currentOfficeId }).then(res => {
            if (res.data.length > 0) {
              this.departmentUserTerm = res.data.join(',')
            }
            // 部门权限用户初始化 companyUserTerm
            this.companyUserTerm = this.departmentUserTerm
          })
        } else if (this.$checkPermission(['role_CustomerPartners_salesPartner'])) {
          // 销售权限用户直接使用当前用户ID
          this.companyUserTerm = this.$store.getters.userId + ''
        }
        // 获取供应商所属部门权限（缓存处理）
        // "查看所有供应商hc"权限优先级最高
        const currentRoles = this.$store.getters.roles || []
        let hasViewAllSupplierHc = false
        for (const role of currentRoles) {
          if (role.toLowerCase().includes('supplier') && role.toLowerCase().includes('all')) {
            hasViewAllSupplierHc = true
            break
          }
        }
        if (hasViewAllSupplierHc) {
          this.supplierDepartmentTerm = 'all'
        } else if (!this.supplierDepartmentTerm) {
          getSupplierDepartmentPermissions().then(res => {
            if (res && res.data && res.data.length > 0) {
              this.supplierDepartmentTerm = res.data.join(',')
            } else {
              this.supplierDepartmentTerm = ''
            }
          }).catch(() => {
            this.supplierDepartmentTerm = ''
          })
        }
      }
    },
    partnersApproved() {
      this.customSearchItemsInit()
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    this.isHC = String(cache.config.get('ToExoSystem')) === 'HC'
    this.extendedInterestRate = (Number(cache.config.get('ExtendedInterestRate')) !== 0) // 免息公司
    this.showIfRisk = (Number(cache.config.get('oujianPartner')) === 1) // CARGO-45565 客商数据CargoWare读取欧坚数据库
    this.differentiateCustomerAndSupplierFees = Number(cache.config.get('differentiateCustomerAndSupplierFees')) === 1 // 区分客户和供应商费用
    this.isCancelPartnersApproved = [1, 2, 3, 4].includes(Number(cache.config.get('PartnersApproved'))) // 合作伙伴“取消审核”按钮 当参数PartnersApproved配置等于1/2/3/4时，显示此按钮。
    this.customSearchItemsInit()
    this.useCheckRule = Number(cache.config.get('useCheckRule')) === 1
    this.wtOpenConfig = Number(cache.config.get('wtOpenConfig')) === 1
    if (!this.partnerPrivilegeBranches) {
      await hasPartnerPrivilegeBranches().then(res => {
        this.partnerPrivilegeBranches = res.data
      })
    }
    this.lobs = SystemConstants.FBA_LOBS
    this.roleTypes = await CargoOfRoleTypeUtil.getCompanyUserListRoleTypes()
  },
  methods: {
    // 自定义高级查询条件初始化
    customSearchItemsInit() {
      const customSearchItems = []
      // 客户类型
      const valueContent = getSearchConditionDropList(this.serviceType)
      let searchField = this.selectAdvancedSearchCargoType('Partners.customerSupplierType', 'companyType', valueContent)
      if (valueContent.length === 1) {
        searchField.defaultValue = [valueContent[0].code]
      } else if (valueContent.length > 1) {
        searchField.defaultValue = [valueContent[0].code]
      }
      customSearchItems.push(searchField.formatObj2Json())
      const boolValueExpression = {
        valueType: 'static',
        valueContent: [
          { code: null, chineseName: this.$t('constant.all'), englishName: this.$t('constant.all') },
          { code: 1, chineseName: this.$t('constant.yes'), englishName: this.$t('constant.yes') },
          { code: 0, chineseName: this.$t('constant.no'), englishName: this.$t('constant.no') }
        ]
      }
      // 审核状态
      if (this.partnersApproved > 0) {
        searchField = this.selectAdvancedSearchField('Partners.approvedState', 'company.APPROVED_STATE', {
          valueType: 'static',
          valueContent: [
            { code: 0, chineseName: this.$t('CargoMsg.Cargo_NotReviewed'), englishName: this.$t('CargoMsg.Cargo_NotReviewed') },
            { code: 1, chineseName: this.$t('Message.Approved'), englishName: this.$t('Message.Approved') },
            { code: 2, chineseName: this.$t('CargoMsg.Cargo_Denied'), englishName: this.$t('CargoMsg.Cargo_Denied') },
            { code: 3, chineseName: this.$t('CargoMsg.Cargo_UnderReview'), englishName: this.$t('CargoMsg.Cargo_UnderReview') }
          ]
        }, 1)
        customSearchItems.push(searchField.formatObj2Json())
      }
      // 是否有效
      searchField = this.selectAdvancedSearchField('baseInfo.partner.isActive', 'company.ACTIVE', boolValueExpression)
      customSearchItems.push(searchField.formatObj2Json())
      // 仓库类型
      searchField = this.selectAdvancedSearchField('Partners.WarehouseType', 'warehouse.WAREHOUSE_TYPE', {
        valueType: 'static',
        valueContent: SystemConstants.WARE_HOUSE_TYPE_LIST
      }, 1)
      customSearchItems.push(searchField.formatObj2Json())
      // 信控设置日期类型
      searchField = this.selectAdvancedSearchField('Partners.credit_creditControl_date', 'creditInfo.REMARKS', {
        valueType: 'static',
        valueContent: DATETYPE_TYPE
      }, 0)
      customSearchItems.push(searchField.formatObj2Json())

      // 结算方式
      searchField = this.selectAdvancedSearchField('Partners.settlementMethod', 'creditInfo.CREDIT_DATE_TYPE', {
        valueType: 'static',
        valueContent: SystemConstants.SETTLEMENT_TYPE
      }, 0)
      customSearchItems.push(searchField.formatObj2Json())

      // 黑名单
      searchField = this.selectAdvancedSearchField('Partners.blacklist', 'creditInfo.BLACKLIST', {
        valueType: 'static',
        valueContent: SystemConstants.BLACK_LIST
      }, 0)
      customSearchItems.push(searchField.formatObj2Json())

      // 是否显示HQ客户
      searchField = this.selectAdvancedSearchField('Partners.isShowHq', 'isShowHq', {
        valueType: 'static',
        valueContent: SystemConstants.BLACK_LIST
      }, 0)
      customSearchItems.push(searchField.formatObj2Json())

      // 揽货类型
      searchField = this.selectAdvancedSearchField('Partners.customerSpace1', 'cargoSource', {
        valueType: 'static',
        valueContent: SystemConstants.CARGO_SALES_TYPE
      }, 1)
      customSearchItems.push(searchField.formatObj2Json())

      // CARGO-40303 中邮，合作伙伴新增“内部公司”优化 (3)合作伙伴列表增加查询条件 “内部往来公司” （可选下拉值：全部、是、否）
      searchField = this.selectAdvancedSearchField('Partners.internalCorrespondent', 'company.INTERNAL_CORRESPONDENT', {
        valueType: 'static',
        valueContent: SystemConstants.INTERNAL_CORRESPONDENT_STATE
      }, 0)
      customSearchItems.push(searchField.formatObj2Json())

      // 是否上传合同附件
      searchField = this.selectAdvancedSearchField('Partners.whetherUploadContractAttachment', 'contract.isUploadAttachment', boolValueExpression)
      customSearchItems.push(searchField.formatObj2Json())

      // CARGO-42653 中邮，新增订舱代理级别
      searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.defaultValue = ''
      searchField.multiple = 0
      searchField.itemLabel = 'Partners.BookingAgentLevel'
      searchField.itemName = 'company.BOOKING_AGENT_LEVEL'
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.dataProvider = SystemConstants.BOOKING_AGENT_LEVEL
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL]
      searchField.defaultConditionVal = AdvancedSearchConsts.OPERATOR_EQUAL.code
      searchField.action = String(cache.config.get('ToExoSystem')) === 'zy' ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      customSearchItems.push(searchField.formatObj2Json())

      if (!this.isHC) {
        searchField = new AdvancedSearchField()
        searchField.itemType = 'roleType'
        searchField.defaultValue = ''
        searchField.multiple = 0
        searchField.itemLabel = 'Partners.positionType'
        searchField.itemName = 'companyUser.ROLE_TYPE'
        searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dataProvider = CargoOfRoleType.ROLE_TYPES
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL]
        searchField.defaultConditionVal = AdvancedSearchConsts.OPERATOR_EQUAL.code
        searchField.action = AdvancedSearchField.UPDATE_ACTION
        searchField.cascade = {
          'itemType': 'select',
          'itemCondition': [{
            'code': '=',
            'chineseName': '等于',
            'englishName': 'Equal',
            'children': null,
            'selected': false
          }],
          'defaultConditionVal': '=',
          'itemName': 'companyUser.USER_ID',
          'itemLabel': 'roleType',
          'subType': '',
          'itemValue': '',
          'defaultValue': '',
          'defaultSelected': 1,
          'selected': 0,
          'fieldType': 'FIELD_DROP_DOWN_LIST',
          'lock': false,
          'headers': null,
          'fields': null,
          'tagName': '',
          'tagValue': ''
        }
        customSearchItems.push(searchField.formatObj2Json())
      }

      // 合作伙伴类型
      // searchField = new AdvancedSearchField()
      // searchField.itemType = 'select'
      // searchField.defaultValue = ''
      // searchField.multiple = 0
      // searchField.itemLabel = 'CargoMsg.Cargo_CategoryOfPartner'
      // searchField.itemName = 'partnerType'
      // searchField.dropdownDataRef = 'SystemConstants.PARTNER_TYPE'
      // searchField.dataCacheKey = 'local_cache_SystemConstants$PARTNER_TYPE'
      // searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      // searchField.defaultSelected = 1
      // searchField.selected = 0
      // searchField.valueExpression = ''
      // searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL]
      // searchField.defaultConditionVal = AdvancedSearchConsts.OPERATOR_EQUAL.code
      // searchField.action = this.differentiateCustomerAndSupplierFees ? AdvancedSearchField.ADD_ACTION : AdvancedSearchField.REMOVE_ACTION
      // customSearchItems.push(searchField.formatObj2Json())

      this.customSearchItems = customSearchItems
      if (this.customSearchItems.length > 0) {
        this.searchItemAutoInit = true
      }
      // 免息公司
      if (this.extendedInterestRate) {
        const interestFreeExpression = boolValueExpression.valueContent.filter(p => p.code !== null)
        searchField = this.selectAdvancedSearchField('Partners.interestFreeCompany', 'company.INTEREST_FREE', {
          valueType: 'static',
          valueContent: interestFreeExpression
        })
        customSearchItems.push(searchField.formatObj2Json())
      }
      // CARGO-45565 客商数据CargoWare读取欧坚数据库
      if (this.showIfRisk) {
        searchField = this.selectAdvancedSearchField('Partners.IfRisk', 'company.IF_RISK', {
          valueType: 'static',
          valueContent: SystemConstants.IS_RISK_STATE
        }, 0)
        customSearchItems.push(searchField.formatObj2Json())
      }
      // CARGO-48534 合作伙伴-客户 移除供应商有关字段
      if (this.isSalesForSzfs) {
        // 指定货代理
        searchField = new AdvancedSearchField()
        searchField.itemLabel = 'queryJob.nominatedAgent'
        searchField.itemName = 'portDestinationAgent.DESTINATION_AGENT_ID'
        searchField.fieldType = 'FIELD_CUSTOMER'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        customSearchItems.push(searchField.formatObj2Json())
        // 舱位承运人
        searchField = new AdvancedSearchField()
        searchField.itemLabel = 'CargoMsg.Cargo_shippingCarrier'
        searchField.itemName = 'cabin.CARRIER_ID'
        searchField.fieldType = 'FIELD_COMPANY'
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        customSearchItems.push(searchField.formatObj2Json())
      }
    },
    selectAdvancedSearchField(itemLabel, itemName, valueExpression, multiple) {
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'select'
      searchField.defaultValue = multiple ? [] : ''
      searchField.multiple = multiple || 0
      searchField.itemLabel = itemLabel || ''
      searchField.itemName = itemName || ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.valueExpression = valueExpression || ''
      searchField.itemCondition = multiple ? [AdvancedSearchConsts.OPERATOR_IN] : [AdvancedSearchConsts.OPERATOR_EQUAL]
      searchField.defaultConditionVal = multiple ? AdvancedSearchConsts.OPERATOR_IN.code : AdvancedSearchConsts.OPERATOR_EQUAL.code
      searchField.action = 2
      return searchField
    },
    selectAdvancedSearchCargoType(itemLabel, itemName, values) {
      const searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.ADD_ACTION
      searchField.itemType = 'advanceSelect2'
      searchField.multiple = 1
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = itemName
      searchField.itemLabel = itemLabel
      searchField.tagValue = 'code'
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.defaultValue = []
      searchField.dataProvider = values
      return searchField
    },
    async toQuery(data) {
      if (data) {
        this.searchConditions.pageNum = 1
        this.searchConditions.snapshotConditions = data.conditions
        // 快捷查询
        if (data.simpleTriggerMode) {
          const conditions = []
          conditions.push(new AdvancedSearchOption('FIELD_TEXT', 'companyName', data.conditions, AdvancedSearchConsts.OPERATOR_LIKE.code).formatObj2Json())
          this.searchConditions.snapshotConditions = conditions
        }
        if (Number(cache.config.get('IsSpecifiedSalesBusiness')) !== 1) {
          for (const index in this.searchConditions.snapshotConditions) {
            const item = this.searchConditions.snapshotConditions[index]
            if (item.itemName === 'companyUser.ROLE_TYPE' && item.value !== CargoOfRoleType.SALES_TYPE.code) {
              this.$message.warning(this.$t('Partners.servicePersonnelSettingNotEnabled'))
              return
            }
          }
        }
      }
      // 若客户类型不存在默认第一条
      let containType = false
      for (const index in this.searchConditions.snapshotConditions) {
        const item = this.searchConditions.snapshotConditions[index]
        if (item.fieldName === 'companyType') {
          containType = true
          break
        }
      }
      if (!containType) {
        const conditions = this.searchConditions.snapshotConditions
        const valueContent = getSearchConditionDropList(this.serviceType)
        if (valueContent.length >= 1) {
          conditions.push(new AdvancedSearchOption('FIELD_MULTI_DROP_DOWN_LIST', 'companyType', [valueContent[0].code], AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
          this.searchConditions.snapshotConditions = conditions
        }
      }
      const companyUser = this.companyUserTerm
      const loading = getLoading4Cxt(this)
      const supplierDepartment = this.isAdmin ? '' : this.supplierDepartmentTerm
      await getAdvancedList({
        branchId: this.currentOfficeId,
        pageNum: this.searchConditions.pageNum,
        pageSize: this.searchConditions.pageSize,
        conditions: this.searchConditions.snapshotConditions,
        companyUser: companyUser,
        supplierDepartment: supplierDepartment,
        customerSupplierUser: !this.showPartnerButton
      }).then(res => {
        this.rowData = res.data.list
        this.rowData.forEach((item) => {
          if (item.creditDateLimited !== '') {
            item.accountingPeriod = `${item.creditDateLimited}${this.termUnitConvert(item.termUnit)}`
          } else {
            item.accountingPeriod = ''
          }
          if (item.credit !== '') {
            item.quota = `${item.credit}${this.quotaConvert(item.currency)}`
          } else {
            item.quota = ''
          }
        })
        this.searchConditions.pageNum = res.data.pageNum
        this.searchConditions.pageSize = res.data.pageSize
        this.searchConditions.total = Number(res.data.total)
        this.$emit('rowDataChange', this.rowData)
        this.gridApi.clearFocusedCell()
      }).finally(() => {
        loading.close()
      })
    },
    // 追加查询（添加或者覆盖旧数据）
    addToQuery(uuidList) {
      return this.syncManager.execute(() => {
        const loading = getLoading4Cxt(this)
        return getCompanyList({ uuidList }).then(res => {
          let hasNew = false // 是否有新增数据
          for (const item of res.data.list) {
            const index = this.rowData.findIndex(p => p.uuid === item.uuid)
            if (index >= 0) {
              this.rowData[index] = item
            } else {
              this.rowData.push(item)
              hasNew = true
            }
          }
          if (hasNew) {
            /* 记录勾选项 */
            const rows = this.gridApi.getSelectedRows()
            if (rows.length > 0) {
              const keys = Array.from(rows, p => p.uuid)
              setTimeout(() => {
                const nodes = this.gridApi.rowModel.rowsToDisplay
                for (const node of nodes) {
                  if (keys.includes(node.data.uuid)) {
                    node.setSelected(true)
                  }
                }
              }, 100)
            }
          } else {
            const nodes = this.gridApi.rowModel.rowsToDisplay
            for (const item of res.data.list) {
              const node = nodes.find(p => p.data.uuid === item.uuid)
              node.setData(item)
            }
          }
          this.$emit('rowDataChange', this.rowData)
        }).finally(() => {
          loading.close()
        })
      })
    },
    updateRowData(uuidList) {
      for (let i = uuidList.length - 1; i >= 0; --i) {
        if (this.rowData.findIndex(p => p.uuid === uuidList[i]) < 0) {
          uuidList.splice(i, 1)
        }
      }
      if (uuidList.length > 0) {
        for (const uuid of uuidList) {
          // 清缓存
          Company.clearCache(uuid)
        }
        this.addToQuery(uuidList)
      }
      this.toQuery()
    },
    // 签约状态
    contractStatusLabFun(value) {
      let result
      if (Number(value) === 1) {
        result = SeaExportConstants.CONTRACT_STATE_OUT_OF_DATE
      } else if (Number(value) === 2) {
        result = SeaExportConstants.CONTRACT_STATE_SIGNED
      } else {
        result = SeaExportConstants.CONTRACT_STATE_NO
      }
      return this.$i18n.locale === 'zh' ? result.chineseName : result.englishName
    },
    toNew() {
      this.$emit('addCompany')
    },
    async toDelete() {
      // if (!this.$store.getters.isAdmin) {
      //   this.$message.warning(this.$t('Partners.deletedWithAdministratorPermission'))
      //   return
      // }
      const row = this.selectedNode ? this.selectedNode.data : null
      if (!row) {
        this.$message.warning(this.$t('Partners.partnerNotSelected'))
        return
      }
      // if (row.branchId !== this.$store.getters.currentOfficeId) {
      //   this.$confirm(this.$t('Partners.DeleteBranchNotSameTip'), this.$t('common.tips.prompt'), {
      //     confirmButtonText: this.$t('Message.GotIt'),
      //     showCancelButton: false,
      //     type: 'warning'
      //   })
      //   return
      // }
      const checkHQReadOnly = this.checkHQReadOnlyPermission(this.gridApi.getSelectedRows())
      if (!checkHQReadOnly) {
        return
      }
      // if (!this.partnerPrivilegeBranches.includes(this.$store.getters.currentOfficeId)) {
      //   this.$message.warning(this.$t('Partners.BranchNoDeletePartnerPermission'))
      //   return
      // }
      // 审批中 不能操作
      if (row.approvedState === 3) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DataUnderReviewCheckRetry'))
        return
      }
      const loading = getLoading4Cxt(this)
      try {
        const { data } = await checkQuotationClient({ companyUuid: row.uuid, cmpIdx: row.cmpIdx })
        if (!data.canDelete) {
          this.$message.warning(this.$t('Partners.partnerBeenUsedByBusiness'))
          return
        }
        if (!data.associatedCRM) {
          this.$message.warning(this.$t('Partners.removeAssociationWithPartner'))
          return
        }
        if (data.hasSubsidiaryCompany) {
          this.$message.warning(this.$t('Partners.changeParentCompany'))
          return
        }
      } finally {
        loading.close()
      }
      await this.$confirm(this.$t('Message.AreYouSureYouWantToDelete1') + row.chineseName + this.$t('Message.AreYouSureYouWantToDelete2'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        const loading = getLoading4Cxt(this)
        try {
          await delCompany(row.uuid)
          this.filter.pageNum = 1
          this.toQuery()
          this.$message.success(this.$t('common.tips.deleteSuccess'))
        } finally {
          loading.close()
        }
      })
    },
    toLook() {
      if (!this.selectedNode) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$emit('viewCompany', this.selectedNode.data)
    },
    async toCommit() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      for (const row of rows) {
        // 不等于未审批 不能提交
        if (row.approvedState !== 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CanSubmitOnlyUnreviewedPartner'))
          return
        }
      }
      if (this.useCheckRule) {
        this.loading = getLoading4Cxt()
        await this.checkingCompanyData(rows, CheckRuleConstants.NODE_COMMIT_PARTNER.code)
        const needCheck = rows.filter(p => p.needShowDialog)
        if (needCheck && needCheck.length > 0) {
          this.loading.close()
          // 提交合作伙伴时，弹出验证弹框
          const callBack = async() => {
            await this.commit()
          }
          this.batchCheckingWindow.checkNode = CheckRuleConstants.NODE_COMMIT_PARTNER.code
          this.batchCheckingWindow.jobs = rows
          this.batchCheckingWindow.callBack = callBack
          this.batchCheckingWindow.closeCallback = null
          this.batchCheckingWindow.visible = true
        } else {
          await this.commit()
        }
      } else {
        await this.commit()
      }
    },
    commit() {
      if (this.loading) {
        this.loading.close()
      }
      this.$confirm(this.$t('CargoMsg.Cargo_PartnerApprovalRequired'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(() => {
        this.doCompanyBpmHandler()
      })
    },
    async doCompanyBpmHandler() {
      const rows = this.gridApi.getSelectedRows()
      const companyVo = {
        branchId: this.$store.getters.currentOfficeId,
        companyList: rows
      }
      const companyBpm = await createCompanyBpmFunc(companyVo).then(res => res.data)

      if (companyBpm) {
        this.companyApplyWindow.companyBpm = companyBpm
        this.companyApplyWindow.visible = true
      }
    },
    async closeAndRefresh() {
      this.companyApplyWindow.visible = false
      this.toQuery()
    },
    async checkingCompanyData(list, code) {
      try {
        await Promise.all(
          Array.from(list, async p => {
            const res = await checkAnyContent({ company: p }, code)
            p.checkingResult = res.data
            p.lob = 'PT' // 无实际意义，仅是控件要求必传值
            p.jobNo = p.chineseName
            for (const checkRule of p.checkingResult) {
              if (!(checkRule && checkRule.expressions)) {
                continue
              }
              for (const item of checkRule.expressions) {
                if (!item.match) {
                  p.needShowDialog = true
                  break
                }
              }
            }
          })
        )
      } catch (error) {
        console.log(error)
      }
    },
    toAudit() {
      const row = this.selectedNode ? this.selectedNode.data : null
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (this.serviceType === PartnerServiceItem.PARTNER_SERVICE_ALL.code && !this.btnRole.partnersAuditBtnPermission) {
        const customer = this.isCustomer(row)
        const supplier = this.isSupplier(row)
        if (this.btnRole.customerAuditBtnPermission && !this.btnRole.supplierAuditBtnPermission) {
          if (!customer || (customer && supplier)) {
            this.$message.warning(this.$t('Partners.noAuthorityToAuditSupplierRolePartners'))
            return false
          }
        } else if (!this.btnRole.customerAuditBtnPermission && this.btnRole.supplierAuditBtnPermission) {
          if (!supplier || (customer && supplier)) {
            this.$message.warning(this.$t('Partners.noAuthorityToAuditCustomerRolePartners'))
            return false
          }
        }
      }
      this.$emit('audit', row)
    },
    // 是否合作伙伴中包含客户
    isExistCustomer(companyList) {
      return companyList.filter(p => this.isCustomer(p)).length > 0
    },
    // 是否合作伙伴中包含供应商
    isExistSupplier(companyList) {
      return companyList.filter(p => this.isSupplier(p)).length > 0
    },
    isCustomer(p) {
      return p.customer || p.seaCmp || p.airCmp || p.shipper || p.consignee || p.notify || p.tradersSign || p.factorySign || p.other
    },
    isSupplier(p) {
      return p.bookingAgent || p.seaCmpAgent || p.overseaAgent || p.designationAgent || p.localAgent || p.settlementAgent || p.customsBroker ||
        p.warehouse || p.truckCmp || p.portAgent || p.forwardingAgent || p.loadingPlaceCompany || p.signBillPlaceCompany || p.dischargePortCompany ||
        p.destinationPortCompany || p.terminalCompany
    },
    toCancelAudit() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      let companys = []
      for (const item of rows) {
        // 只保留已审核的
        if (item.approvedState === 1) {
          companys.push(item)
        }
      }
      if (companys.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleastAudit'))
        return
      }
      if (!this.btnRole.partnersCancelAuditBtnPermission) {
        const customer = this.isExistCustomer(companys)
        const supplier = this.isExistSupplier(companys)
        if (this.btnRole.customerCancelAuditBtnPermission && !this.btnRole.supplierCancelAuditBtnPermission) {
          if (!customer || (customer && supplier)) {
            companys = companys.filter(p => !this.isSupplier(p))
            this.$message.warning(this.$t('Partners.noAuthorityToAuditSupplierRolePartners'))
          }
        } else if (!this.btnRole.customerCancelAuditBtnPermission && this.btnRole.supplierCancelAuditBtnPermission) {
          if (!supplier || (customer && supplier)) {
            companys = companys.filter(p => !this.isCustomer(p))
            this.$message.warning(this.$t('Partners.noAuthorityToAuditCustomerRolePartners'))
          }
        }
        if (companys.length === 0) return
      }
      const uuidList = []
      for (const item of companys) {
        uuidList.push(item.uuid)
      }
      const params = {}
      params.uuidList = uuidList
      this.loading = getLoading()
      cancelAuditCompany(params).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_ReviewCancelledSuccessfully'))
        // 刷新缓存数据（合作伙伴）
        const resultData = res.data
        if (resultData.length > 0) {
          for (const item of resultData) {
            // 刷新缓存数据（合作伙伴）
            updateBasicDataForSingle(basicCacheKeys.basic_data_Company, item)
          }
        }
        // 刷新页面
        this.toQuery()
      }).finally(() => {
        this.loading.close()
      })
    },
    toPrint() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const params = {}
      params.COMPANY_UUID = Array.from(rows, p => p.uuid)
      params.USER_ID = this.$store.getters.userId
      this.templateSelectorDialog.category = 'PARTNER'
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
    },
    toInviteB2B() {
      this.$emit('inviteB2B')
    },
    toGrantPriceLevel() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      for (const item of rows) {
        if (!item.customer) {
          this.$message.warning(this.$t('Partners.partnersWithCustomerAttributeCanBeSelected'))
          return
        }
      }
      const checkHQReadOnly = this.checkHQReadOnlyPermission(rows)
      if (!checkHQReadOnly) {
        return
      }
      const priceLevelCache = localStorage.getItem('PRICE_LEVEL_AUTHORIZATION')
      if (priceLevelCache) {
        this.priceLevelDialog.form = JSON.parse(priceLevelCache)
        this.priceLevelDialog.form.uuidList = []
      } else {
        this.priceLevelDialog.form = {
          uuidList: [],
          fcl: 3,
          lcl: 3,
          air: 3,
          fba: 3
        }
      }
      rows.forEach(p => {
        this.priceLevelDialog.form.uuidList.push(p.uuid)
      })
      this.priceLevelDialog.visible = true
    },
    executeGrantPriceLevel() {
      addPartnerAuthorizationByBatch(this.priceLevelDialog.form).then(res => {
        this.gridApi.deselectAll()
        localStorage.setItem('PRICE_LEVEL_AUTHORIZATION', JSON.stringify(this.priceLevelDialog.form))
        this.priceLevelDialog.visible = false
        this.$message.success(this.$t('Partners.authorizationSucceeded'))
      })
    },
    toMerge() {
      const row = this.selectedNode ? this.selectedNode.data : null
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (row.global) {
        this.$message.warning(this.$t('Partners.groupCompaniesCannotBeMerged'))
        return
      }
      const checkHQReadOnly = this.checkHQReadOnlyPermission(this.gridApi.getSelectedRows())
      if (!checkHQReadOnly) {
        return
      }
      // 审批中 不能操作
      if (row.approvedState === 3) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DataUnderReviewCheckRetry'))
        return
      }
      // if (row.branchId !== this.$store.getters.currentOfficeId) {
      //   this.$confirm(this.$t('Partners.MergeBranchNotSameTip'), this.$t('common.tips.prompt'), {
      //     confirmButtonText: this.$t('Message.GotIt'),
      //     showCancelButton: false,
      //     type: 'warning'
      //   })
      //   return
      // }
      // if (!this.partnerPrivilegeBranches.includes(this.$store.getters.currentOfficeId)) {
      //   this.$message.warning(this.$t('Partners.BranchNoMergePartnerPermission'))
      //   return
      // }
      this.mergeDialog.partnerName = row.chineseName
      this.mergeDialog.fromUuid = row.uuid
      this.mergeDialog.cmpIdx = row.cmpIdx
      if (this.$refs.mergePartner) {
        this.$refs.mergePartner.needLoadingData = true // CARGO-21374H5合作伙伴 合并弹窗数据更新问题
        this.$refs.mergePartner.onShow()
      } else {
        setTimeout(() => {
          this.$refs.mergePartner.onShow()
        })
      }
      this.mergeDialog.visible = true
    },
    async executeMerge() {
      const rows = this.$refs.mergePartner.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const row = rows[0]
      if (row.cmpIdx === this.mergeDialog.cmpIdx) {
        this.$message.warning(this.$t('Partners.chooseADifferentPartner'))
        return
      }
      // 是否生成过凭证
      const loading = getLoading4Cxt(this.$refs.mergeDialog)
      try {
        const resp = await checkUsedByAccountingDocument({ cmpIdx: row.cmpIdx })
        await this.checkUsedByAccountingHandler(row, resp)
      } finally {
        loading.close()
      }
    },
    // 判断是否生成凭证
    async checkUsedByAccountingHandler(mergeRow, resp) {
      const res = resp.data
      const item = {}
      item.companyUuid = mergeRow.uuid
      const name = mergeRow.chineseName
      if (res) {
        await this.$confirm('【' + name + '】' + this.$t('Partners.vouchersBeenGeneratedContinue'), this.$t('Message.Prompt'), { closeOnClickModal: false })
      }
      // 按companyUUID查询CRM客户
      const response = await checkQuotationClient(item)
      await this.checkMergeHandler(mergeRow, response)
    },
    async checkMergeHandler(mergeRow, resp) {
      const data = resp.data
      // if (!data.associatedCRM) {
      //   this.$message.warning(this.$t('Partners.mergedPartnerBeenAssociatedWithCRM') + '，' + this.$t('Partners.removeAssociationWithPartner'))
      //   return
      // }
      if (!data.associatedCRM) {
        const text = "<span style='margin: 0; text-align: center; font-size: 18px; color: red;'>" + this.$t('Partners.mergedPartnerBeenAssociatedWithCRM2') + '</span>'
        this.$confirm(this.$t('Partners.mergedPartnerBeenAssociatedWithCRM1', [text]), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          dangerouslyUseHTMLString: true,
          type: 'warning',
          closeOnClickModal: false
        }).then(async() => {
          // 清除CRM
          await deleteCompanyCRMFunc({ companyUuid: mergeRow.uuid })
          await this.doCheckMergeHandler(mergeRow)
        })
      } else {
        await this.doCheckMergeHandler(mergeRow)
      }
      // this.$message.success(this.$t('Partners.mergeSuccessful'))
    },
    /**
     * 继续合并
     * @param mergeRow
     * @returns {Promise<void>}
     */
    async doCheckMergeHandler(mergeRow) {
      await mergeCompanies({ fromUuid: mergeRow.uuid, toUuid: this.mergeDialog.fromUuid })
      this.addToQuery([mergeRow.uuid, this.mergeDialog.fromUuid])
      this.mergeDialog.visible = false
      this.$refs.mergePartner.needLoadingData = true // CARGO-20769合并弹窗是否有效字段未刷新
      this.$alert("<h6 style='margin: 0; text-align: center; font-size: 14px; color: #000;'>" + this.$t('Information.MergeInProgressPleaseWait') + "</h6><p style='text-align: center; margin: 5px auto 20px;'>" + this.$t('Information.YouExpectedToCompleteLater') + '</p>', this.$t('Information.Notice'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('Information.Confirm')
      })
    },
    toEditInvoiceRiseByBatch() {
      this.editInvoiceHeadVisible = true
    },
    toEditServicePersonByBatch() {
      if (Number(cache.config.get('IsSpecifiedSalesBusiness')) === 1) {
        this.editCompanyUserVisible = true
      } else {
        this.editPartnerSaleVisible = true
      }
    },
    btnInitTemplateClickHandler() {
      ExportUtils.downloadTemplateFile('ImportPartnerTemplate.xls', 'partner')
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (fileType !== 'xls' && fileType !== 'xlsx') {
        this.$message.warning(this.$t('Partners.uploadXLSFormatFile'))
        return false
      }
      this.loading = getLoading4Cxt(this)
      return true
    },
    uploadSuccess(response, file, fileList) {
      this.loading.close()
      if (response && response.data) {
        const data = response.data
        if (data.isSuccess) {
          this.$message.success(this.$t('Message.ImportSuccessful1'))
          for (const index in data.companyList) {
            if (Object.hasOwnProperty.call(data.companyList, index)) {
              const item = data.companyList[index]
              updateBasicDataForSingle(basicCacheKeys.basic_data_Company, item)
            }
          }
        } else {
          this.$message.warning(data.message)
        }
        this.exportResult = data.errorContent || ''
        // 刷新页面
        this.toQuery()
      } else {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    uploadError() {
      this.loading.close()
      this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
    },
    btnDownLoadResultHandler() {
      this.url = URL.partner.exportExcelResult
      this.formEntries = [
        { name: 'sessionId', value: getToken() },
        { name: 'fileSubPath', value: 'partner' },
        { name: 'template', value: 'ImportPartnerTemplate.xls' },
        { name: 'content', value: this.exportResult },
        { name: 'fileName', value: 'ImportPartnerResult.xls' }
      ]
      this.$nextTick(() => {
        this.$refs.form.submit()
      })
    },
    exportAgentsHandler() {
      let active = -1
      if (this.filter && this.filter.hasOwnProperty('active') && this.filter.active !== '') {
        active = this.filter.active ? 1 : 0
      }
      window.open(URL.partner.exportAgent + '?sessionId=' + getToken() + '&active=' + active)
    },
    // 批量查询公司在当前是否有有效的客户合同
    async batchQueryCustomerCompanyIsOverFunc(selections) {
      const customerIdList = []
      selections.map((item) => {
        customerIdList.push(item.cmpIdx)
      })
      const res = await batchQueryCustomerCompanyIsOver(customerIdList)
      if (res.ok) {
        if (Number(res.data)) {
          this.remindShow = true
        } else {
          this.remindShow = false
        }
      }
    },
    // 批量维护信控按钮
    maintainControl() {
      const selections = getGridSelected(this.gridOptions)
      console.log('selections', selections)
      if (selections.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (Number(cache.config.get('PartnersApproved')) === 3) {
        for (const item of selections) {
          if (Number(item.approvedState) === 1) {
            this.$message.warning(this.$t('Partners.PartnersApprovedTips'))
            return
          }
        }
      }
      if (Number(cache.config.get('PartnersApproved')) === 4) {
        for (const d of selections) {
          if (Number(d.approvedState) === 3) {
            this.$message.warning(this.$t('CargoMsg.Cargo_DataUnderReviewCheckRetry'))
            return
          }
        }
      }
      const checkHQReadOnly = this.checkHQReadOnlyPermission(selections)
      if (!checkHQReadOnly) {
        return
      }
      this.maintainCreditControl = true
      this.batchQueryCustomerCompanyIsOverFunc(selections)
    },
    // 批量黑名单设置按钮
    maintainBlacklist() {
      const selections = getGridSelected(this.gridOptions)
      if (selections.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (Number(cache.config.get('PartnersApproved')) === 3) {
        for (const item of selections) {
          if (Number(item.approvedState) === 1) {
            this.$message.warning(this.$t('Partners.PartnersApprovedTips'))
            return
          }
        }
      }
      if (Number(cache.config.get('PartnersApproved')) === 4) {
        for (const d of selections) {
          if (Number(d.approvedState) === 3) {
            this.$message.warning(this.$t('CargoMsg.Cargo_DataUnderReviewCheckRetry'))
            return
          }
        }
      }
      const checkHQReadOnly = this.checkHQReadOnlyPermission(selections)
      if (!checkHQReadOnly) {
        return
      }
      this.maintainBlacklistVisible = true
    },
    maintainDefaultCreditInfo() {
      this.maintainDefaultCreditControl = true
    },
    // 批量维护信控弹窗保存
    async creditControlSave() {
      this.loading = getLoading()
      const rows = this.gridApi.getSelectedRows()
      const companyTreeList = rows.map((item) => {
        return {
          uuid: item.uuid,
          cmpIdx: item.cmpIdx,
          chineseName: item.chineseName
        }
      })
      // CARGO-34522 批量维护信控，结算方式选项不起效
      if (this.creditDateTypeObj.val1 === 'n') {
        this.form.creditDateType = this.creditDateTypeObj.val2
      } else {
        this.form.creditDateType = this.creditDateTypeObj.val1
      }
      const data = {
        creditInfo: this.form,
        branchId: this.$store.getters.currentOfficeId,
        companyTreeVOList: companyTreeList
      }
      const res = await batchSaveCreditInfos(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        if (res.data) {
          const remind = this.$t('SeaExport.ContractPeriod').replace('${0}', res.data)
          this.$confirm(remind, this.$t('Information.Notice'), {
            cancelButtonText: this.$t('SeaExport.Close'),
            showConfirmButton: false,
            type: 'warning'
          })
        }
        this.toQuery()
        this.cancel()
        this.$message.success(this.$t('Information.Success'))
      }
    },
    // 批量维护信控弹窗取消
    cancel() {
      this.maintainCreditControl = false
      this.reset()
    },
    // 重置批量维护信控弹窗内容
    reset() {
      this.form = {
        creditDateLimited: 0,
        termUnit: 0,
        credit: 0,
        currency: 'RMB',
        remarks: 'ETD'
      }
    },
    // 批量黑名单设置弹窗保存
    async blacklistSave() {
      this.loading = getLoading()
      const rows = this.gridApi.getSelectedRows()
      const companyTreeList = rows.map((item) => {
        return {
          uuid: item.uuid,
          cmpIdx: item.cmpIdx,
          chineseName: item.chineseName
        }
      })
      const data = {
        creditInfo: { blacklist: this.blacklistForm.blacklist },
        branchId: this.$store.getters.currentOfficeId,
        companyTreeVOList: companyTreeList
      }
      const res = await batchSaveBlacklist(data).finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        this.toQuery()
        this.blacklistCancel()
        this.$message.success(this.$t('Information.Success'))
      }
    },
    // 批量黑名单设置弹窗取消
    blacklistCancel() {
      this.maintainBlacklistVisible = false
      this.blacklistForm = { blacklist: false }
    },
    btnDownLoadPartnerHandler() {
      const loading = getLoading4Cxt(this)
      downLoadPartners({ officeId: this.currentOfficeId, url: cache.config.get('SyncThirdPartyBossPartnerUrl') || '' }).then(res => {
        if (res.data > 0) {
          this.$message.success(this.$t('Partners.updateSucceeded'))
        } else {
          this.$message.success(this.$t('Partners.failedUpdateSupplierData'))
        }
      }).finally(() => {
        loading.close()
      })
    },
    // 一键添加平台认证合作伙伴
    createWTCompanyHandler() {
      this.openSendList.visible = true
    },
    visibleHandler() {
      this.openSendList.visible = false
    },
    mergeSuccess() {
      // CacheManager.loadCache(Company.CODE_NAME)
      this.$message.success(this.$t('Pricing.StatSucceed'))
    },
    // 转换结算方式
    settlementConvert(value) {
      switch (value) {
        case 0:
          return this.$t('Partners.monthlySpecifiedDate')
        case -1:
          return this.$t('Partners.monthlySettlement')
        case -2:
          return this.$t('Partners.weeklySettlement')
        case -3:
          return this.$t('Partners.semilunarKnot')
        case -4:
          return this.$t('Partners.dailySettlement')
      }
    },
    // 转换日期类型
    dateTypeConvert(company) {
      if (company.normalRuleContactExist) {
        let text = ''
        company.contractList.forEach(contract => {
          const value = contract.dateType
          text = text + ColumnUtils.columnLabelFunc(DATETYPE_TYPE, value)
          text = text + '/'
        })
        return text.slice(0, -1)
      }
      const value = company.dateType
      return ColumnUtils.columnLabelFunc(DATETYPE_TYPE, value)
    },
    // 结算类型
    settlementTypeLabFun(company) {
      if (company == null) return ''
      if (company.normalRuleContactExist) {
        return ColumnUtils.settlementTypeLabFun(company)
      }
      return company.settlementType
    },
    // 额度
    creditLabelFunc(company) {
      if (company.normalRuleContactExist) {
        let text = ''
        company.contractList.forEach(contract => {
          if (contract.credit === 0 || contract.credit) {
            text = text + `${contract.credit}${this.quotaConvert(contract.currency)}`
          } else {
            text = text + ''
          }
          text = text + '/'
        })
        return text.slice(0, -1)
      }
      if (company.credit !== '') {
        return `${company.credit}${this.quotaConvert(company.currency)}`
      } else {
        return ''
      }
    },
    // 账期
    accountingPeriodLabelFunc(company) {
      if (company.normalRuleContactExist) {
        let text = ''
        company.contractList.forEach(contract => {
          if (contract.creditDateLimited !== '') {
            text = text + `${contract.creditDateLimited}${this.termUnitConvert(contract.termUnit)}`
          } else {
            text = text + ''
          }
          text = text + '/'
        })
        return text.slice(0, -1)
      }
      if (company.creditDateLimited !== '') {
        return `${company.creditDateLimited}${this.termUnitConvert(company.termUnit)}`
      } else {
        return ''
      }
    },
    // 账期单位转换
    termUnitConvert(value) {
      switch (value) {
        case 0:
          return this.$t('Partners.day')
        case 1:
          return this.$t('Partners.week')
        case 2:
          return this.$t('Partners.month')
      }
    },
    // 额度币种单位转换
    quotaConvert(value) {
      switch (value) {
        case 'RMB':
          return 'RMB'
        case 'USD':
          return 'USD'
        default:
          return value
      }
    },
    // CARGO-40477 13855兰高：合作伙伴服务人员批量新增
    btnAddOrUpdateServiceHandle() {
      switch (this.btnAddOrUpdateService) {
        case this.$t('Partners.batchEditServer'):
          // 原本批量编辑的逻辑
          this.toEditServicePersonByBatch()
          break
        case this.$t('Partners.batchAddServer'):
          // 新增的批量新增逻辑
          // 2）点击“批量新增服务人员”校验是否勾选合作伙伴，不满足条件提示：请选择要新增服务人员的合作伙伴
          // eslint-disable-next-line no-case-declarations
          const selectedRows = this.gridApi.getSelectedRows()
          if (!selectedRows || selectedRows.length === 0) {
            this.$message.warning(this.$t('Partners.batchAddServerNoSelected'))
            return
          }
          //    校验IsSpecifiedSalesBusiness当前操作的分公司配置是否为1以及选中的合作伙伴存在，不满足条件则提示：您选择的合作伙伴不支持维护维护服务人员
          if (Number(cache.config.get('IsSpecifiedSalesBusiness')) !== 1) {
            this.$message.warning(this.$t('Partners.batchAddServerConfigError'))
            return
          }
          if (Number(cache.config.get('PartnersApproved')) === 4) {
            for (const d of selectedRows) {
              if (d.approvedState === 3) {
                this.$message.warning(this.$t('CargoMsg.Cargo_DataUnderReviewCheckRetry'))
                return
              }
            }
          }
          const checkHQReadOnly = this.checkHQReadOnlyPermission(selectedRows)
          if (!checkHQReadOnly) {
            return
          }
          // 3）符合条件后点击【批量新增服务人员】弹窗显示见附件“新增服务人员”，新增逻辑与单个合作伙伴新增功能保持一致，其中需要注意岗位类型选择非【销售】【揽货销售】并且业务类型选择【海运出口】会出现揽货类型选择框，不必填
          this.editDialog.form = {
            ...this.editDialog.initForm
          }
          this.editDialog.visible = true
          break
        case this.$t('CargoMsg.Cargo_BatchEditEnterpriseWechat'):
          this.toEditEnterpriseWechatByBatch()
          break
      }
    },
    roleTypeChange() {
      if (this.editDialog.form.roleType === CargoOfRoleType.SALES_TYPE.code || this.editDialog.form.roleType === CargoOfRoleType.SALES_OF_GOODS.code || this.editDialog.form.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) {
        this.editDialog.form.cargoSource = ''
      }
    },
    userCustomLabel(user) {
      const name = this.$selectByLang(user.chineseName, user.englishName)
      let officeCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', user.defaultOfficeId, 'code')
      if (officeCode) {
        officeCode = `【${officeCode}】`
      }
      return `${name}${officeCode}【${user.email}】`
    },
    lobChange() {
      if (this.editDialog.form.lob !== 'SE') {
        this.editDialog.form.cargoSource = ''
      }
    },
    getRoleTypeEnglishName(val) {
      const roleType = CargoOfRoleType.getCargoOfRoleTypeByCode(val)
      if (roleType) {
        return roleType.englishName
      } else {
        return '-'
      }
    },
    btnAddServiceSaveHandle() {
      const form = this.editDialog.form
      const check = this.checkCompanyUserParam(form)
      if (!check) {
        this.editDialog.visible = false
        return
      }
      // 校验被勾选的参数
      const selectedRows = this.gridApi.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('Partners.batchAddServerNoSelected'))
        this.editDialog.visible = false
        return
      }
      // 校验是否为客户类型
      const isCustomer = selectedRows.every(val => {
        return val.customer
      })
      if (([CargoOfRoleType.SALES_TYPE.code, CargoOfRoleType.CSR_TYPE.code, CargoOfRoleType.DOC_TYPE.code, CargoOfRoleType.SALES_OF_GOODS.code,
        CargoOfRoleType.USER_DEFINED_ROLE1.code, CargoOfRoleType.USER_DEFINED_ROLE2.code, CargoOfRoleType.USER_DEFINED_ROLE3.code, CargoOfRoleType.USER_DEFINED_ROLE3.code,
        CargoOfRoleType.USER_DEFINED_ROLE4.code, CargoOfRoleType.USER_DEFINED_ROLE5.code, CargoOfRoleType.USER_DEFINED_ROLE6.code, CargoOfRoleType.USER_DEFINED_ROLE7.code
      ].includes(this.editDialog.form.roleType) || (this.isHC && this.editDialog.form.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code)) && !isCustomer) {
        this.$message.warning(this.$t('Partners.partnersWithCustomerAttributeCanBeSelected'))
        return
      }
      // 校验是否为目的港代理类型
      const isOverseaAgent = selectedRows.every(val => {
        return val.overseaAgent
      })
      if (!this.isHC && this.editDialog.form.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code && !isOverseaAgent) {
        this.$message.warning(this.$t('Partners.partnersWithOverseaAgentAttributeCanBeSelected'))
        return
      }
      // 构建参数
      const obj = {}
      obj.uuids = selectedRows.map(row => row.uuid)
      // 岗位类型
      obj.roleType = form.roleType
      obj.branchId = this.$store.getters.currentOfficeId
      // 业务类型 如果为空默认为ALL
      obj.lob = form.lob ? form.lob : 'ALL'
      // 揽货类型
      obj.cargoSource = form.cargoSource
      // 用户
      obj.userId = form.userId
      // 是否默认
      obj.defaultUser = form.defaultUser
      // 备注
      obj.remarks = form.remarks
      // 是否代理商
      obj.acrossTenant = false
      // 调用接口处理
      const loading = getLoading4Cxt(this)
      batchAddUser(obj).then(res => {
        // 成功后将选择的数据清空
        if (!res.ok && res.message) {
          this.$message.warning(res.message)
        } else {
          // 给出提示
          this.$message.success(this.$t('common.tips.saveSuccess'))
        }
      }).finally(() => {
        loading.close()
        // 成功与否都需要将弹窗关闭
        this.editDialog.visible = false
      })
    },
    // 验证参数
    checkCompanyUserParam(form) {
      if (!form.userId) {
        this.$message.warning(this.$t('Information.UserCannotBeEmpty'))
        return false
      }
      const user = this.$refs.userSelect.options.find(row => row.userId === form.userId)
      if (form.roleType === 0) {
        this.$message.warning(this.$t('Partners.user') + '【' + user.chineseName + '】' + this.$t('Partners.positionTypeNotSelected'))
        return false
      }
      return true
    },
    // CARGO-43014 增加编辑HQ分公司合作伙伴编辑权限
    checkHQReadOnlyPermission(selectedRows) {
      if (this.$store.getters.isAdmin || !this.$checkPermission(['button_SMPartner_HQReadOnly'])) {
        return true
      }
      // 判断选中数据的所属公司是否等于右上角的分公司
      const isBelongToBranchId = selectedRows.every(val => {
        return val.branchId === this.$store.getters.currentOfficeId
      })
      if (isBelongToBranchId) {
        return true
      } else {
        let names = selectedRows
          .filter(val => val.branchId !== this.$store.getters.currentOfficeId)
          .map(val => this.isZh ? val.chineseName : val.englishName)
          .join(', ')
        if (names) {
          names = ' [' + names + '] '
        }
        this.$confirm(this.$t('Partners.parter') + names + this.$t('Partners.operateBranchNotSameTip'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('Message.GotIt'),
          showCancelButton: false,
          type: 'warning'
        })
        return false
      }
    },
    toEditEnterpriseWechatByBatch() {
      this.editEnterpriseWechatVisible = true
    },
    newCustomerApplication(ifCustomer) {
      if (ifCustomer) {
        this.customerApplicationDialogVisible = true
      } else {
        this.supplierApplicationDialogVisible = true
      }
    }
  }
}
</script>
<style scoped lang="scss">
.credit-control-save {
  .title{
    color:#000;
  }
  .title-block-color{
    width: 5px;
    height: 14px;
    background: #1F75D5;
    display: inline-block;
    vertical-align: text-bottom;
    margin-right: 10px;
  }
  .form-item-350 ::v-deep {
    .el-form-item__content {
      width: 350px;
      .el-date-editor.el-input {
        width: 350px;
      }
    }
  }
  .margin-Right50 {
    margin-right: 50px;
  }
}
</style>
